export default __webpack_public_path__ + "static/media/H.306b6933.png";